import React, { useState } from "react";
import PermissionWrapper from "./PermissionWrapper";

// Компонент для відображення ціни з модальним вікном (універсальна версія)
function PriceModal({ info, children }) {
  // Стан для відображення модального вікна
  const [showModal, setShowModal] = useState(false);

  // Очікуємо масив пунктів
  const items = Array.isArray(info) ? info : [];

  // Обробники для показу вікна при наведенні курсора
  const handleMouseEnter = () => {
    setShowModal(true);
  };

  // Обробники для приховування вікна при забиранні курсора
  const handleMouseLeave = () => {
    setShowModal(false);
  };

  return (
    <div
      className="price-modal"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {showModal && (
        <div className="info-tooltip" role="tooltip">
          {items.map((item, idx) => (
            <PermissionWrapper key={idx} requiredPermission={item.requiredPermission}>
              <p>
                <strong>{item.label}:</strong> {item.value}
              </p>
            </PermissionWrapper>
          ))}
        </div>
      )}
    </div>
  );
}

export default PriceModal;
